import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import {settings} from '@/plugins/settings';
import {helpdeskAxios} from '@/plugins/helpdeskAxios';
import responseHandler from '@/plugins/errorHandling';

export interface IGmailAccount {
  id: number;
  email: string;
  token_expires_at: string | null;
  created_at: string;
  updated_at: string;
}

interface AccountsState {
  accounts: IGmailAccount[];
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
  oauthUrl: string | null;
  errors: any;
}

const state: AccountsState = {
  accounts: [],
  currentPage: 1,
  lastPage: 1,
  total: 0,
  perPage: 15,
  oauthUrl: null,
  errors: {},
};

const getters: GetterTree<AccountsState, RootState> = {
  accounts:    (state) => state.accounts,
  currentPage: (state) => state.currentPage,
  lastPage:    (state) => state.lastPage,
  total:       (state) => state.total,
  perPage:     (state) => state.perPage,
  oauthUrl:    (state) => state.oauthUrl,
};

const mutations: MutationTree<AccountsState> = {
  errors(state, payload: any) { state.errors = payload; },
  accountsLoaded(state, payload: any) {
    state.accounts    = payload.data;
    state.currentPage = payload.current_page;
    state.lastPage    = payload.last_page;
    state.total       = payload.total;
    state.perPage     = payload.per_page;
  },
  accountDeleted(state, _payload: any) {},
  oauthUrlLoaded(state, payload: any) { state.oauthUrl = payload && payload.url ? payload.url : null; },
  syncDone(_state, _payload: any) {},
};

const actions: ActionTree<AccountsState, RootState> = {
  fetchAccounts: ({commit}, params: {page?: number; per_page?: number} | undefined) => {
    const query = new URLSearchParams();
    if (params && params.page)     query.set('page',     String(params.page));
    if (params && params.per_page) query.set('per_page', String(params.per_page));
    const qs = query.toString() ? '?' + query.toString() : '';
    return responseHandler.handle(
      () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/accounts' + qs, method: 'GET'}),
      commit, 'accountsLoaded',
    );
  },
  deleteAccount: ({commit}, id: number) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/accounts/' + id, method: 'DELETE'}),
    commit, 'accountDeleted', null, false,
  ),
  getOAuthUrl: ({commit}) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/oauth/google/url', method: 'GET'}),
    commit, 'oauthUrlLoaded',
  ),
  syncEmails: ({commit}) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/sync', method: 'POST'}),
    commit, 'syncDone',
  ),
};

export const helpdeskAccountsModule: Module<AccountsState, RootState> = {
  namespaced: true, state, getters, mutations, actions,
};
